import { Stack, Tab, Tabs } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import PageLayout from '@shared/shell/Layout/PageLayout';
import { InventoryOnboardingOverlay } from '@features/tutorial';
import Inventory from './Inventory';
import { Warehouses } from '@features/warehouses';

enum PageTab {
  INVENTORY = 'inventory',
  WAREHOUSES = 'warehouses',
}

const InventoryCatalog = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const tab = location.pathname === '/inventory/warehouses' ? PageTab.WAREHOUSES : PageTab.INVENTORY;

  const handleTabChange = (_: React.SyntheticEvent, value: PageTab) => {
    if (value === PageTab.WAREHOUSES) {
      navigate('/inventory/warehouses');
    } else {
      navigate('/inventory');
    }
  };

  return (
    <PageLayout title="Inventory">
      <Stack borderBottom={1} borderColor="divider">
        <Tabs value={tab} onChange={handleTabChange}>
          <Tab sx={{ textTransform: 'none' }} label="Inventory" value={PageTab.INVENTORY} />
          <Tab sx={{ textTransform: 'none' }} label="Warehouses" value={PageTab.WAREHOUSES} />
        </Tabs>
      </Stack>

      {tab === PageTab.INVENTORY && <Inventory />}
      {tab === PageTab.WAREHOUSES && <Warehouses />}

      <InventoryOnboardingOverlay />
    </PageLayout>
  );
};

export default InventoryCatalog;
